<canvas #canvasDocument class="canvas"></canvas>
<div>{{ fps }}</div>
<div class="footer">
  <input type="button" class="demo-button" value="All objects" (tap)="addAllObjects()" />
  <input type="button" class="demo-button" value="512 000" (tap)="add500k()" />
  <input type="button" class="demo-button" value="Unique" (tap)="addSingleObjects()" />
  <input type="button" class="demo-button" value="X-ray" (tap)="addXRayObjects()" />
  <input type="button" class="demo-button" value="Toggle X-ray" (tap)="toggleXRay()" />
  <label for="downsample" class="demo-label">Downsampling:</label>
  <input
    type="range"
    id="downsample"
    #downsample
    (input)="setDownsample(downsample.value)"
    [min]="downsampleMin"
    [max]="downsampleMax"
    value="1"
  />
</div>
